import { useCallback } from "react"

export default function useOpportunityController({
  clinicId,
  openAppointmentFromActionPanel,
  openPatientFromActionPanel,
  openFromOpportunityGap
}) {
  const handleOpportunityAction = useCallback((row) => {
    const actionType = row?.actionType
    const payload = row?.payload || {}
    const targetPatientId = row?.patientId || payload.patientId

    if (actionType === "OPEN_FINANCE") {
      if (!targetPatientId || !clinicId) return
      window.location.href = `/patients/${targetPatientId}?clinicId=${clinicId}&tab=FINANCE`
      return
    }

    if (actionType === "OPEN_PLAN") {
      if (!targetPatientId || !clinicId) return

      if (payload.tooth || payload.condition) {
        localStorage.setItem(
          "odontoflow_plan_prefill",
          JSON.stringify({
            patientId: targetPatientId,
            clinicId,
            tooth: payload.tooth ?? null,
            surface: payload.surface || "ALL",
            condition: payload.condition || ""
          })
        )
      }

      window.location.href = `/treatment-plans?patientId=${targetPatientId}&clinicId=${clinicId}`
      return
    }

    if (actionType === "SCHEDULE_RECALL" || actionType === "SCHEDULE_TREATMENT") {
      if (!targetPatientId || !clinicId) return

      localStorage.setItem(
        "odontoflow_new_appointment_context",
        JSON.stringify({
          patientId: targetPatientId,
          clinicId,
          treatmentId: payload.treatmentId || "",
          treatmentPlanItemId: payload.treatmentPlanItemId || "",
          tooth: payload.tooth ?? null,
          surface: payload.surface || "ALL",
          source: "daily_opportunity"
        })
      )

      window.location.href = "/agenda"
    }
  }, [clinicId])

  const handleOpportunityPanelAction = useCallback((item) => {
    if (item.appointmentId) {
      openAppointmentFromActionPanel(item.appointmentId)
      return
    }

    if (item.gapStart) {
      openFromOpportunityGap(item.gapStart)
      return
    }

    if (item.patientId) {
      openPatientFromActionPanel(item.patientId)
      return
    }

    alert("Aquí luego abriremos módulo de recall inteligente")
  }, [
    openAppointmentFromActionPanel,
    openFromOpportunityGap,
    openPatientFromActionPanel
  ])

  return {
    handleOpportunityAction,
    handleOpportunityPanelAction
  }
}